const CACHE_TIME = 5 * 1000; // 5 seconds

const cache = new Map();

export function set(key, value) {
  cache.set(key, value);
}

export function unset(key) {
  cache.delete(key);
}

export function get(key) {
  return cache.get(key);
}

export function setExpirable(key, value, time = CACHE_TIME) {
  set(key, value);
  setTimeout(function () {
    unset(key);
  }, time);
}



// WEBPACK FOOTER //
// ./src/transport/utils/cache.js